import React from 'react'
import classNames from 'classnames'
import { FlexColumn, FlexRow } from '@/atoms/FlexContainers'
import { EyebrowMD, EyebrowSM, EyebrowXS, HeadingMD, HeadingSM, TitleMD, TitleXS } from '@/atoms/Text'
import { FlexibleBookingToolTip } from '@/views/TicketCheckoutViews/ShowtimesView/components/ToolTips/FlexibleBookingToolTip'
import { SpecificTimesToolTip } from '@/views/TicketCheckoutViews/ShowtimesView/components/ToolTips/SpecificTimesToolTip'
import { CountdownTimer } from '@/views/TicketCheckoutViews/ShowtimesView/components/banners/EarlyBirdBanner/CountdownTimer'
import { EarlyBirdContentProps } from '@/views/TicketCheckoutViews/ShowtimesView/components/banners/EarlyBirdBanner/EarlyBirdBanner'

export const SmallContent = ({ code, bannerValues, discount, refetch }: EarlyBirdContentProps) => {
  const imageSrc = bannerValues['large'].image
  if (!imageSrc) return null

  return (
    <div className={classNames('relative mb-2 rounded-xl ', bannerValues.bgColor)}>
      <div className=" relative h-full w-full rounded-xl @container/banner @[390px]:min-h-[160px] ">
        <div className={'relative z-0 h-full overflow-hidden rounded-xl  @[390px]:min-h-[160px] lg:!min-h-[140px]'}>
          <div className={'absolute left-0 top-0 z-10   h-[160px] w-full min-w-[200px] lg:!h-[140px]'}>
            <div className={'relative flex w-full justify-end'}>
              <div className="relative right-0 top-0 z-10 block  w-full bg-gradient-to-r from-[#EAE0D9] to-transparent to-100%  opacity-70 @[390px]:h-[160px] @[600px]:w-[120px] lg:!h-[140px]" />
            </div>
          </div>
          <div
            className={
              'relative z-0 h-full min-h-[120px] overflow-hidden rounded-xl  opacity-20 @[390px]:min-h-[160px]'
            }
          >
            <div
              className=" absolute -left-[5.2em] -top-[3.4em] z-[5] h-[1000px] scale-[.54] bg-right-top bg-no-repeat @[415px]:!-left-[30px] "
              style={{
                backgroundImage:
                  "url('https://images.angelstudios.com/image/upload/v1743806779/the-last-rodeo/last-rode-neal-closeup-wide-03.jpg')",
                backgroundSize: '1000px 516px',
                width: '1000px',
                transformOrigin: 'top left',
              }}
            />
          </div>
        </div>
        {/* Main content container - absolute positioning to fill parent */}
        <div className="item-stretch @ absolute inset-0 z-10 flex w-full min-w-[300px] justify-start rounded-xl px-0  @[390px]:px-1 @[475px]:justify-between @[475px]:px-4">
          {/*FIRST COLUMN*/}
          <FlexColumn className="flex min-w-[170px] justify-center py-2 pl-1 @[390px]:min-w-[210px]">
            <FlexRow className={'justify-center'}>
              <TitleMD className={'hidden @[390px]:block'} weight={'semibold'}>
                Buy Early. Save Big.
              </TitleMD>
            </FlexRow>
            <FlexRow className="justify-center pl-0">
              <HeadingMD className="hidden @[390px]:block" weight={'bold'} color="black">
                {discount}% off
              </HeadingMD>
              <HeadingSM className="@[390px]:hidden" weight={'bold'} color="black">
                {discount}% off
              </HeadingSM>
            </FlexRow>
            <FlexRow className="justify-center pl-0">
              <EyebrowMD
                weight={'medium'}
                className="mt-1 hidden bg-[#B22E14] p-2 text-center uppercase @[390px]:inline"
                color="white"
              >
                use code: <span className="  font-bold text-white">{code}</span>
              </EyebrowMD>
              <EyebrowSM
                weight={'medium'}
                className="mt-1 inline bg-[#B22E14] p-2 text-center uppercase @[390px]:hidden"
                color="white"
              >
                use code: <span className="  font-bold text-white">{code}</span>
              </EyebrowSM>
            </FlexRow>
            <div className="mt-2 flex justify-center @[390px]:hidden">
              <SpecificTimesToolTip
                titleText={'On Select Showtimes'}
                extraSmall={true}
                buttonClassName="opacity-70 focus-visible:outline-none focus-visible:ring-offset-transparent focus-visible:ring-transparent"
              />
            </div>
            <div className={'mt-1 hidden justify-center @[390px]:flex'}>
              <FlexibleBookingToolTip
                className="mt-2"
                buttonColor={'gray-800'}
                buttonClassName="bg-none border-[1px] !border-gray-800 text-gray-800 focus-visible:outline-none focus-visible:ring-offset-transparent focus-visible:ring-transparent"
              />
            </div>
          </FlexColumn>
          {/*SECOND COLUMN*/}
          <FlexColumn className="hidden min-w-[180px]  items-center justify-center @[390px]:flex">
            <TitleXS className="text-center" weight="semibold" color="black">
              On Select Showtimes
            </TitleXS>
            <EyebrowXS weight={'semibold'} className="uppercase opacity-70 " color="black">
              Opening Week (MAY 22 - 25)
            </EyebrowXS>
            <div className="flex justify-center">
              <SpecificTimesToolTip
                extraSmall={true}
                buttonClassName="opacity-70 focus-visible:outline-none focus-visible:ring-offset-transparent focus-visible:ring-transparent"
              />
            </div>
            <div className="border-none pt-2">
              <CountdownTimer onCountdownEnd={refetch} textColor={'black'} />
            </div>
          </FlexColumn>
          <FlexColumn className=" flex min-w-[180px]  items-center justify-center @[390px]:hidden">
            <div className="border-none pt-2">
              <CountdownTimer onCountdownEnd={refetch} textColor={'black'} />
            </div>
          </FlexColumn>
        </div>
      </div>
    </div>
  )
}
